import React, { useState, useEffect } from "react";
import { FaRegUserCircle } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import UserProfileAvatar from "../comp/Component/UserProfileAvatar";
import Axios from "../comp/Utils/axios";
import SummaryAPI from "../comp/Commson/summaryApi";
import { AxiosToastError } from "../comp/Utils/AxiosToastError";
import toast from "react-hot-toast";
import { setUserDetails } from "../comp/Store/Userslice";
import fetchUserDetails from "../comp/Utils/fetchUserDetail";

const Profile = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);

  const [openProfileAvatarEdit, setProfileAvatarEdit] = useState(false);
  const [userData, setUserData] = useState({
    name: user?.name || "",
    email: user?.email || "",
    mobile: user?.mobile || "",
    avatar: user?.avatar || "",
  });
  const [loading, setLoading] = useState(false);

  // ✅ Sync Redux user data to local component state
  useEffect(() => {
    if (user) {
      setUserData({
        name: user?.name || "",
        email: user?.email || "",
        mobile: user?.mobile || "",
        avatar: user?.avatar || "",
      });
    }
  }, [user]);

  const handleOnchange = (e) => {
    const { name, value } = e.target;
    setUserData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await Axios({
        ...SummaryAPI.updateuserdetails,
        data: userData,
      });

      const { data: responseData } = response;

      if (responseData.success) {
        toast.success(responseData.message);

        // ✅ Refresh user details after update
        const newUserData = await fetchUserDetails();
        dispatch(setUserDetails(newUserData.data));

        // ✅ Update local component state to reflect immediately
        setUserData((prev) => ({
          ...prev,
          ...newUserData.data,
        }));
      }
    } catch (error) {
      AxiosToastError(error);
    } finally {
      setLoading(false);
    }
  };

  // ✅ This function will be called after avatar upload is complete
  const handleAvatarUpdated = async () => {
    setProfileAvatarEdit(false);
    const newUserData = await fetchUserDetails();
    dispatch(setUserDetails(newUserData.data));
    setUserData((prev) => ({
      ...prev,
      ...newUserData.data,
    }));
    toast.success("Profile picture updated successfully!");
  };

  return (
    <div className="w-full mx-auto bg-white shadow rounded-lg p-6">
      <div>
        {/* Avatar Section */}
        <div className="flex flex-col items-center justify-center md:items-start gap-3 mb-10">
          <div className="w-46 h-46 bg-gray-200 flex items-center justify-center rounded-full overflow-hidden shadow-md">
            {userData?.avatar ? (
              <img
                alt={userData?.name || "User Avatar"}
                src={userData.avatar}
                className="w-32 h-32 object-cover rounded-full border border-gray-300"
              />
            ) : (
              <FaRegUserCircle size={100} className="text-gray-400" />
            )}
          </div>

          {/* Change Avatar Button */}
          <button
            className="ml-4 px-4 py-2 rounded-md border border-gray-300 hover:bg-gray-100 transition"
            onClick={() => setProfileAvatarEdit(true)}
          >
            Change Avatar
          </button>
        </div>

        {/* Avatar Modal */}
        {openProfileAvatarEdit && (
          <UserProfileAvatar
            close={() => setProfileAvatarEdit(false)}
            onAvatarUpdated={handleAvatarUpdated} // ✅ callback
          />
        )}

        {/* User details form */}
        <form className="flex-1 space-y-6" onSubmit={handleSubmit}>
          {/* Name */}
          <div>
            <label className="block text-base font-medium text-gray-800 mb-2">
              Name
            </label>
            <input
              type="text"
              name="name"
              value={userData.name}
              onChange={handleOnchange}
              placeholder="Enter your name"
              className="w-full text-lg px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:outline-none"
              required
            />
          </div>

          {/* Email */}
          <div>
            <label className="block text-base font-medium text-gray-800 mb-2">
              Email
            </label>
            <input
              type="email"
              name="email"
              value={userData.email}
              onChange={handleOnchange}
              placeholder="Enter your email"
              className="w-full text-lg px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:outline-none"
              required
            />
          </div>

          {/* Mobile */}
          <div>
            <label className="block text-base font-medium text-gray-800 mb-2">
              Mobile
            </label>
            <input
              type="text"
              name="mobile"
              value={userData.mobile}
              onChange={handleOnchange}
              placeholder="Enter your number"
              className="w-full text-lg px-4 py-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-orange-500 focus:outline-none"
              required
            />
          </div>

          {/* Submit */}
          <button
            type="submit"
            className="w-full text-lg font-medium bg-orange-500 text-white py-3 px-6 rounded-md hover:bg-orange-600 transition"
          >
            {loading ? "Loading..." : "Update Profile"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Profile;
